<template>
    <div class="bg-white pa-4 rounded-lg h-100 overflow-y-auto">
        <v-col xl="6" lg="7" md="9" cols="12">
            <v-stepper-vertical color="secondary" eager flat :items="steps" v-model="stepper">
                <template #item.1>
                    <v-form ref="step1Form">
                        <switch-input v-model="form.status" label="وضعیت"></switch-input>
                        <v-radio-group inline v-model="form.gender">
                            <p class="text-meta text-grey-darken-2 mb-0">جنسیت:</p>
                            <v-spacer></v-spacer>
                            <v-radio :value="true" label="مرد"></v-radio>
                            <v-radio :value="false" label="زن"></v-radio>
                            <v-radio :value="null" label="نامشخص"></v-radio>
                        </v-radio-group>
                        <v-row dense>
                            <v-col sm="6" cols="12">
                                <v-text-field
                                    :rules="$validation('required')"
                                    label="* نام"
                                    v-model="form.first_name"
                                    autocomplete="new-password"
                                ></v-text-field>
                            </v-col>
                            <v-col sm="6" cols="12">
                                <v-text-field
                                    :rules="$validation('required')"
                                    label="* نام خانوادگی"
                                    v-model="form.last_name"
                                    autocomplete="new-password"
                                ></v-text-field>
                            </v-col>
                            <v-col sm="6" cols="12">
                                <v-text-field
                                    :rules="$validation([($system.systemSettings.username_type == 'username' ? 'required' : false), ($system.systemSettings.username_regex ? 'regex:' + $system.systemSettings.username_regex : false)].filter(Boolean))"
                                    :label="$system.systemSettings.username_type == 'username' ? '* نام کاربری' : 'نام کاربری'"
                                    :placeholder="$system.systemSettings.username_example"
                                    v-model="form.username"
                                    autocomplete="new-password"
                                ></v-text-field>
                            </v-col>
                            <v-col sm="6" cols="12">
                                <datetime-input
                                    label="تاریخ تولد"
                                    type="date"
                                    clearable
                                    v-model="form.birthday"
                                ></datetime-input>
                            </v-col>
                        </v-row>
                    </v-form>
                </template>
                <template #item.2>
                    <v-form ref="step2Form">
                        <v-text-field
                            :rules="$validation('required:' + ($system.systemSettings.username_type == 'email'))"
                            :label="$system.systemSettings.username_type == 'email' ? '* ایمیل' : 'ایمیل'"
                            v-model="form.email"
                            autocomplete="new-password"
                        ></v-text-field>
                        <v-row dense>
                            <v-col cols="12" sm="5">
                                <v-text-field
                                :rules="$validation('required:' + ($system.systemSettings.username_type == 'mobile'))"
                                :label="$system.systemSettings.username_type == 'mobile' ? '* شماره موبایل' : 'شماره موبایل'"
                                v-model="form.mobile"
                                autocomplete="new-password"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="5">
                                <v-text-field
                                :rules="$validation()"
                                label="تلفن ثابت"
                                v-model="form.landline"
                                autocomplete="new-password"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="2">
                                <v-text-field
                                    :rules="$validation()"
                                    label="داخلی"
                                    v-model="form.interphone"
                                    autocomplete="new-password"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-textarea
                            :rules="$validation()"
                            label="آدرس"
                            no-resize
                            rows="2"
                            v-model="form.address"
                            autocomplete="new-password"
                        ></v-textarea>
                    </v-form>
                </template>
                <template #item.3>
                    <v-form ref="step3Form">
                        <p class="text-small text-grey-darken-1 mb-2 mt-2">چنانچه قصد ایجاد کلمه عبور تصادفی را دارید از تکمیل گزینه‌های زیر خودداری کنید. <br><span v-if="$system.systemSettings.force_users_using_secure_password">(کلمه عبور می‌باید دارای حداقل 8 کاراکتر شامل حروف کوچک و بزرگ انگلیسی، اعداد و علامت‌های خاص باشد.).</span></p>
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    :rules="$validation([$system.systemSettings.force_users_using_secure_password ? 'complex' : false].filter(Boolean))"
                                    :append-inner-icon="pass1 ? 'visibility' : 'visibility_off'"
                                    :type="pass1 ? 'password' : 'text'"
                                    @click:appendInner="() => {pass1 = !pass1}"
                                    label="کلمه عبور"
                                    v-model="form.password"
                                    autocomplete="new-password"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    :rules="$validation([$system.systemSettings.force_users_using_secure_password ? 'complex' : false].filter(Boolean))"
                                    :append-inner-icon="pass2 ? 'visibility' : 'visibility_off'"
                                    :type="pass2 ? 'password' : 'text'"
                                    @click:appendInner="() => {pass2 = !pass2}"
                                    label="تکرار کلمه عبور"
                                    v-model="form.password_confirmation"
                                    autocomplete="new-password"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-form>
                </template>
                <template #item.4>
                    <v-form ref="step4Form">
                        <v-select
                            :rules="$validation('required')"
                            :items="[{name:'مدیر ارشد',id:'full_admin'},{name:'سرپرست شعبه',id:'branch_admin'},{name:'کارشناس و سرپرست دپارتمان',id:'employee'}]"
                            v-if="$auth.user.full_admin"
                            item-title="name"
                            item-value="id"
                            label="* انتخاب نوع کاربری"
                            @update:modelValue="changeUserType"
                            v-model="userType"
                            autocomplete="new-password"
                        ></v-select>
                        <v-slide-y-transition>
                            <v-select
                                :rules="$validation('required')"
                                :items="branches"
                                v-if="$auth.user.full_admin && !form.full_admin"
                                v-model="form.branch_id"
                                item-title="name"
                                item-value="id"
                                label="* انتخاب شعبه"
                                no-data-text="موردی پیدا نشد!"
                                autocomplete="new-password"
                            ></v-select>
                        </v-slide-y-transition>
                        <v-slide-y-transition>
                            <div class="mb-5 px-1" v-if="!form.full_admin && !form.branch_admin && form.branch_id">
                                <v-btn color="secondary" @click="newPosition" :disabled="$auth.user.full_admin && !form.branch_id">
                                    <v-icon color="white" class="me-2" size="14">icon-add</v-icon>جایگاه سازمانی
                                </v-btn>
                                <workingShiftCard
                                    :showDetails="false"
                                    :reRender="positionCardReRender"
                                    :lists="form.employee_fields.positions"
                                    icon="icon-employee"
                                    @editCard="editAction"
                                    @deleteCard="deleteAction"
                                ></workingShiftCard>
                            </div>
                        </v-slide-y-transition>
                    </v-form>
                </template>
                <template #item.5>
                    <v-form ref="step5Form">
                        <div v-if="!!form.branch_admin || !!form.full_admin || !!form.employee_fields.positions.find((x) => x.supervisor)">
                            <v-checkbox
                                v-for="(item, index) in permissions"
                                :key="index"
                                :label="item.name"
                                hide-details
                                :model-value="true"
                                disabled
                            ></v-checkbox>
                        </div>
                        <div v-else>
                            <v-checkbox
                                v-model="local_permissions[item.id]"
                                v-for="(item, index) in permissions"
                                :key="index"
                                :label="item.name"
                                hide-details
                            ></v-checkbox>
                        </div>
                    </v-form>
                </template>
                <template #title="{title}">
                    <span class="text-meta cursor-pointer font-weight-regular">{{title}}</span>
                </template>
                <template #actions="{step}">
                    <div class="mt-3">
                        <v-btn @click="changeStep(step + 1)" color="success" :loading="loading">{{ step == steps.length ? 'ثبت اطلاعات' : 'ثبت و ادامه'}}</v-btn>
                        <v-btn v-if="step > 1" @click="changeStep(step - 1)" color="error" class="ms-3" variant="text" :disabled="loading">بازگشت</v-btn>
                    </div>
                </template>
            </v-stepper-vertical>
        </v-col>
        <v-dialog v-model="dialog" width="550" persistent>
            <v-card tile>
                <v-toolbar color="white">
                    <v-toolbar-title class="text-primary">{{ editLocalPosition ? 'ویرایش جایگاه سازمانی' : 'جایگاه سازمانی جدید'}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="closePosition" :disabled="positionLoading">
                        <v-icon size="23" color="primary">close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-form @submit.prevent="$refs.positionForm.isValid && acceptPosition()" ref="positionForm" class="px-4 pt-4">
                    <p class="text-small mb-4 text-grey-darken-2">تنظیمات زیر نحوه قرارگیری کاربر در ساختار سازمانی و نیز دسترسی به تیکت‌ها را مشخص می‌نمایند.</p>
                    <v-select
                        :rules="$validation('required')"
                        :items="roles"
                        v-model="local_position.role_id"
                        item-title="name"
                        item-value="id"
                        label="* انتخاب نقش"
                        no-data-text="موردی پیدا نشد!"
                    ></v-select>
                    <v-select
                        :rules="$validation('required')"
                        :items="filterDepartments"
                        v-model="local_position.department_id"
                        item-title="name"
                        item-value="id"
                        label="* انتخاب دپارتمان"
                        no-data-text="موردی پیدا نشد!"
                        @update:modelValue="departmentsChange"
                    ></v-select>
                    <v-select
                        :rules="$validation('required')"
                        item-title="name"
                        item-value="id"
                        label="* انتخاب شیفت کاری"
                        multiple
                        v-if="$system.license.features.workingshift"
                        :items="workingshifts"
                        no-data-text="موردی پیدا نشد!"
                        v-model="local_position.workingshifts"
                        :disabled="local_position.department_id > 0 ? false : true"
                        :loading="local_position.department_id && !workingshifts.length ? true : false"
                    >
                        <template #prepend-item>
                            <toggle-select-all @clicked="$text.toggleSelectAll('local_position.workingshifts' , 'workingshifts', $data)" :items='local_position.workingshifts' :all='workingshifts'></toggle-select-all>
                        </template>
                    </v-select>
                    <v-select
                        :rules="$validation()"
                        :items="services"
                        v-model="local_position.services"
                        item-title="name"
                        item-value="id"
                        label="انتخاب محصول/خدمات"
                        no-data-text="موردی پیدا نشد!"
                        v-if="$system.license.features.ticket_auto_assignment"
                        clearable
                        multiple
                    >
                        <template #prepend-item v-if="services.length">
                            <toggle-select-all @clicked="$text.toggleSelectAll('local_position.services' , 'services', $data)" :items='local_position.services' :all='services'></toggle-select-all>
                        </template>
                    </v-select>
                    <v-select
                        :rules="$validation()"
                        :items="ticket_categories"
                        v-model="local_position.ticket_categories"
                        item-title="name"
                        item-value="id"
                        label="انتخاب دسته بندی موضوعی"
                        v-if="$system.license.features.ticket_auto_assignment"
                        no-data-text="موردی پیدا نشد!"
                        clearable
                        multiple
                    >
                        <template #prepend-item v-if="ticket_categories.length">
                            <toggle-select-all @clicked="$text.toggleSelectAll('local_position.ticket_categories' , 'ticket_categories', $data)" :items='local_position.ticket_categories' :all='ticket_categories'></toggle-select-all>
                        </template>
                    </v-select>
                    <switch-input v-model="local_position.default_reciever" false-label="" true-label="" label="گیرنده پیش‌فرض تیکت‌های دپارتمان"></switch-input>
                    <v-card-actions class="pb-4 px-5">
                        <v-btn :loading="positionLoading" variant="flat" color="success" type="submit">ثبت اطلاعات</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn :disabled="positionLoading" variant="text" color="error" @click="closePosition">بستن</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { VStepperVertical } from 'vuetify/labs/VStepperVertical'
export default {
    title: "ایجاد",
    components: {
        VStepperVertical,
    },
    validate(context) {
        return context.auth.user.full_admin || context.auth.user.branch_admin || this.$auth.user.department_admin;
    },
    data() {
        return {
            loading: false,
            pass1: true,
            pass2: true,
            positionCardReRender: false,
            positionLoading:false,
            dialog: false,
            steps: [
                { title: 'اطلاعات هویتی', value: 1 },
                { title: 'اطلاعات تماس', value: 2 },
                { title: 'تنظیمات امنیتی', value: 3 },
                { title: 'جایگاه سازمانی', value: 4 },
                { title: 'تنظیمات دسترسی', value: 5 },
            ],
            stepper: 1,
            editLocalPosition: false,
            editLocalPositionId: null,
            roles: [],
            username_type: this.$system.systemSettings.username_type,
            permissions: [],
            userType: null,
            form: {
                employee: true,
                status: true,
                gender: null,
                first_name: null,
                last_name: null,
                email: null,
                mobile: null,
                password: null,
                password_confirmation: null,
                landline: null,
                employee_fields: {
                    positions: [],
                    permissions: [],
                },
                branch_id: null,
                branch_admin: false,
                full_admin: false,
            },
            local_permissions: {},
            dialogId: 0,
            branches: [],
            services: [],
            departments: [],
            workingshifts: [],
            ticket_categories: [],
            local_position: {
                name: null,
                id: null,
                role_id: null,
                supervisor: false,
                department_id: null,
                workingshifts: [],
                services: [],
                ticket_categories: [],
                default_reciever: false,
            },
            asseccibilities: false,
        };
    },
    computed: {
        filterDepartments() {
            var departments = [...this.departments];
            let choosenDepartments = this.form.employee_fields.positions.map((x) => {return x.department_id;});
            if (this.form.employee_fields.positions.length) {
                departments = departments.filter((x) => {
                    return !choosenDepartments.includes(x.id);
                });
            }
            if (this.form.employee_fields.positions.length && this.editLocalPosition && this.local_position.department_id) {
                let local_department_id = this.form.employee_fields.positions.find(x => x.id == this.local_position.id).department_id;
                departments.push({
                    name: this.departments.find((x) => x.id == local_department_id).name,
                    id: local_department_id,
                });
            }
            return departments;
        },
    },
    methods: {
        async changeStep(step) {
            for (let i = 1; i < step; i++)
                if (this.$refs[`step${i}Form`] && !(await this.$refs[`step${i}Form`]?.validate())?.valid)
                    return this.stepper = i;
            if (step <= this.steps.length)
                this.stepper = step;
            else
                this.submit();
        },
        changeUserType(value) {
            if (value == "full_admin") {
                this.form.full_admin = true;
                this.form.branch_admin = false;
            } else if (value == "branch_admin") {
                this.form.branch_admin = true;
                this.form.full_admin = false;
            } else if (value == "employee") {
                this.form.branch_admin = false;
                this.form.full_admin = false;
            }
            this.messageForAccessibility();
        },
        departmentsChange(value) {
            this.local_position.workingshifts = [];
            this.local_position.services = [];
            if(this.$system.license.features.workingshift)
                this.workingshifts = this.departments.find((x) => x.id == value).workingshifts;
            if(this.$system.license.features.ticket_auto_assignment) {
                this.ticket_categories = this.$system.ticketCategories.filter((x) => x.department_id == value);
                this.services = this.departments.find((x) => x.id == value).services;
            }
            if (this.$refs.positionForm)
                this.$refs.positionForm.resetValidation();
        },
        messageForAccessibility(toast = true){
            if((!!this.form.branch_admin || !!this.form.full_admin || !!this.form.employee_fields.positions.find((x) => x.supervisor)) && !this.asseccibilities){
                this.asseccibilities = true;
                if(toast)
                    this.$toast.warning('تمام دسترسی‌ها به کاربر اختصاص داده شد.');
            }
            else if(!(!!this.form.branch_admin || !!this.form.full_admin || !!this.form.employee_fields.positions.find((x) => x.supervisor)) && this.asseccibilities){
                this.asseccibilities = false;
                if(toast)
                    this.$toast.warning('امکان ویرایش دسترسی‌های کاربر فعال شد.');
            }
        },
        async acceptPosition() {
            this.positionLoading = true;
            let default_reciever = await this.$checkDefaultReciever(this.$auth.user.full_admin ? {department_id: this.local_position.department_id, branch_id: this.form.branch_id} : {department_id: this.local_position.department_id})
            if(this.local_position.default_reciever){
                if(default_reciever.data.user !== 'have_user' && default_reciever.data.user !== 'no_user'){
                    let confirm = await this.$confirm(`<p class="mb-0 text-meta mt-2">در حال حاضر ${default_reciever.data.user} گیرنده پیش‌فرض این دپارتمان است.</p><p class="text-meta mb-0 mt-2">آیا تمایل دارید <b>${this.form.first_name} ${this.form.last_name}</b> جایگزین گیرنده پیش‌فرض شود؟</p>`,
                        { buttonTrueText: "بله", buttonFalseText: "خیر" }
                    );
                    if(!confirm)
                        this.local_position.default_reciever = false;
                }
            }else if(default_reciever.data.user == 'no_user'){
                let confirm = await this.$confirm(`<p class="mb-0 text-meta mt-2">برای این دپارتمان تاکنون گیرنده پیش‌فرض تعریف نشده است.</p><p class="text-meta mb-0 mt-2">آیا تمایل دارید این کاربر به عنوان گیرنده پیش‌فرض تعریف گردد؟</p>`,
                    { buttonTrueText: "بله", buttonFalseText: "خیر" }
                )
                if(confirm)
                    this.local_position.default_reciever = true;
            }
            this.local_position.name = `${this.local_position.role_id === 0 ? "سرپرست دپارتمان" : "کارشناس دپارتمان"} ${this.departments.find((x) => x.id == this.local_position.department_id).name}`;
            if (this.editLocalPosition == true) {
                let position = { ...this.local_position };
                let formPosition = [...this.form.employee_fields.positions];
                let editId = this.editLocalPositionId;
                let idx = formPosition.findIndex(x => x.id == editId);
                this.form.employee_fields.positions[idx] = position;
                position.supervisor = position.role_id === 0 ? true : false;
                this.positionCardReRender = !this.positionCardReRender;
            } else {
                this.local_position.id = ++this.dialogId;
                let position = { ...this.local_position };
                position.supervisor = position.role_id === 0 ? true : false;
                this.form.employee_fields.positions.push(position);
            }
            for (const key in this.local_position) {
                if(Array.isArray(this.local_position[key]))
                    this.local_position[key] = [];
                else
                    this.local_position[key] = null;
            }
            this.workingshifts = [];
            this.services = [];
            this.ticket_categories = [];
            this.positionLoading = false;
            this.dialog = false;
            this.messageForAccessibility();
            if (this.$refs.positionForm)
                this.$refs.positionForm.resetValidation();
        },
        closePosition() {
            for (const key in this.local_position) {
                if(Array.isArray(this.local_position[key]))
                    this.local_position[key] = [];
                else
                    this.local_position[key] = null;
            }
            this.editLocalAction = false;
            this.workingshifts = [];
            this.services = [];
            this.ticket_categories = [];
            this.dialog = false;
            if (this.$refs.positionForm)
                this.$refs.positionForm.resetValidation();
        },
        deleteAction(id) {
            this.editLocalPosition = false;
            let idx = this.form.employee_fields.positions.findIndex((x) => x.id == id);
            this.form.employee_fields.positions.splice(idx, 1);
            this.messageForAccessibility();
        },
        newPosition() {
            this.editLocalPosition = false;
            this.dialog = true;
            for (const key in this.local_position) {
                if(Array.isArray(this.local_position[key]))
                    this.local_position[key] = [];
                else
                    this.local_position[key] = null;
            }
            this.local_position.default_reciever = false;
            if (this.$refs.positionForm)
                this.$refs.positionForm.resetValidation();
        },
        editAction(id) {
            this.editLocalPosition = true;
            let newPosition = {...this.form.employee_fields.positions.find((x) => x.id == id)};
            this.local_position = newPosition;
            if(this.$system.license.features.workingshift)
                this.workingshifts = this.departments.find((x) => x.id == this.local_position.department_id).workingshifts;
            if(this.$system.license.features.ticket_auto_assignment) {
                this.ticket_categories = this.$system.ticketCategories.filter((x) => x.department_id == this.local_position.department_id);
                this.services = this.departments.find((x) => x.id == this.local_position.department_id).services;
            }
            this.editLocalPositionId = id;
            this.dialog = true;
        },
        submit() {
            this.loading = true;
            let form = {...this.form};
            form.employee_fields.permissions = Object.keys(this.local_permissions).filter((key) => {if (this.local_permissions[key] === true) return key;});
            if (form.branch_admin) {
                delete form.employee_fields;
            }
            if (form.full_admin) {
                delete form.employee_fields;
                delete form.branch_id;
            }
            if (Object.hasOwn(form, 'employee_fields') && !!form.employee_fields.positions.find((x) => x.supervisor))
                delete form.employee_fields.permissions;
            form.gender = form.gender === 0 ? null : form.gender;
            if (Object.hasOwn(form, 'employee_fields')) {
                form.employee_fields.positions.forEach((el) => {
                    delete el.name;
                    delete el.id;
                    delete el.role_id;
                    if(!this.$system.license.features.workingshift)
                        delete el.workingshifts;
                    if(!this.$system.license.features.ticket_auto_assignment) {
                        delete el.ticket_categories;
                        delete el.services;
                    }
                });
            }
            if (!form.password) {
                delete form.password;
                delete form.password_confirmation;
            }
            this.$userStore(form).then((res) => {
                if (res && res.status == "CREATED") {
                    this.$auth.fetchUser(true);
                    this.$system.setSystemDefaults(true);
                    this.$toast.success(res.message);
                    this.$router.push({path: '/employees'});
                }
            }).finally(()=>{this.loading = false});
        },
    },
    mounted() {
        this.$nextTick(async () => {
            this.$loading.start();
            this.roles = this.$auth.user.full_admin || this.$auth.user.branch_admin ? [{ name: "سرپرست دپارتمان", id: 0 },{ name: "کارشناس", id: 1 }] : [{ name: "کارشناس", id: 1 }];
            if (this.$auth.user.full_admin)
                this.branches = this.$system.branches;
            await this.$system.setAdminDefaults();
            this.departments = this.$system.departmentsAdmin;
            this.permissions = this.$system.permissions;
            this.messageForAccessibility(false);
            this.$loading.finish();
        });
    },
};
</script>
